import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { ErrorType, reportErrorToSentry } from "@/utils/error";

const useRouterErrorHandler = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    if (error) {
      // Sentry 會自動捕捉頁面 path，尚無特殊需求，故先不手動在 context上傳 route path
      reportErrorToSentry(error, undefined, ErrorType.ROUTER_ERROR);
    }
  }, [error]);

  return { error };
};

export default useRouterErrorHandler;
